import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function FAQ() {
  const { t } = useTranslation("slotenmaker-eindhoven");
  const items = t("faq.items", { returnObjects: true }) as Array<{
    q: string;
    a: string;
  }>;
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="bg-brand-cream py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight mb-10 md:mb-14">
          {t("faq.h2")}
        </h2>

        <div className="max-w-[900px] flex flex-col gap-3">
          {items.map((item, i) => (
            <div
              key={i}
              className="bg-white rounded-xl border border-brand-border/60 overflow-hidden"
            >
              <button
                type="button"
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
                aria-expanded={open === i}
              >
                <span className="font-geist font-semibold text-sm md:text-base text-brand-text pr-4">
                  {item.q}
                </span>
                <span className="flex-shrink-0">
                  {open === i ? (
                    <i className="ri-subtract-line w-5 h-5 flex items-center justify-center text-brand-text/60"></i>
                  ) : (
                    <i className="ri-add-line w-5 h-5 flex items-center justify-center text-brand-text/60"></i>
                  )}
                </span>
              </button>
              {open === i && (
                <div className="px-5 md:px-6 pb-5">
                  <p className="font-geist text-sm md:text-base text-brand-text/70 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}